export default __webpack_public_path__ + "media/images/burger-7c3bdbeb7035d6283cd22b656b1b93be.svg";